/**
 * Culture Page
 *
 * This is a thin wrapper around the generic SystemWorkspacePage.
 * The actual workspace logic is handled by the generic component.
 */

import React from "react";
import { SystemWorkspaceWrapper } from "./SystemWorkspacePage";
import type { DatasetName } from "@/common/constants";

/**
 * Required datasets for the Culture workspace
 */
const CULTURE_REQUIRED_DATASETS: DatasetName[] = [
  "culture",
  "attrition_drivers",
];

/**
 * Culture workspace page component
 */
const CulturePage: React.FC = () => {
  return (
    <SystemWorkspaceWrapper
      workspaceId="culture"
      requiredDatasets={CULTURE_REQUIRED_DATASETS}
    />
  );
};

export default CulturePage;
